import { render, staticRenderFns } from "./DebugToggler.vue?vue&type=template&id=4817e91a&"
import script from "./DebugToggler.vue?vue&type=script&lang=ts&"
export * from "./DebugToggler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports